export const uniqueId = (array: any[]): number => {
  const numb = array.map((item: any) => {
    return Number(item?._id.match(/\d+/g));
  });
  const arrayNumbs = numb?.length === 0 ? [0] : numb;
  const max = Math.max(...arrayNumbs);

  return max + 1;
};
